import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import y from 'y4/Utils';
import DateFilterItem from './DateFilterItem';
import Input from './Input';
import DynamicSelect from '../form/DynamicSelect';

/**
 * FilterItem component renders a filter item for the FilterPanel.
 * It allows users to input filter criteria for a specific field.
 *
 * @param {*} param0
 * @returns
 */
const FilterItem = ({ panel, filter, values, changed }) => {
  const onChange = useCallback(
    ({ target: { value } }) => {
      const v = _.trim(value);
      const dic = {};
      if (_.isEmpty(v)) {
        dic[filter.name] = null;
      } else {
        dic[filter.name] = v; //equal
        if (filter.type === 'Text') {
          if (!y.include(v, '~') && !y.include(v, ',')) {
            dic[`${filter.name}_api`] = `$c$${v}$`; //contain
          }
        }
      }
      changed(dic);
    },
    [filter]
  );

  if (filter.type === 'DateTime') {
    return <DateFilterItem filter={filter} values={values} changed={changed} />;
  } else if (filter.extraType == 'Quote' || filter.extraType == 'BrieflyCode') {
    return (
      <DynamicSelect
        dataCode={panel.dataCode}
        field={filter}
        row={values}
        onChange={changed}
        filter={true}
      />
    );
  } else {
    return (
      <Input
        type="text"
        placeholder={filter.title}
        onChange={onChange}
        value={_.get(values, filter.name) ?? ''}
      />
    );
  }
};
FilterItem.propTypes = {
  panel: PropTypes.object,
  filter: PropTypes.object,
  values: PropTypes.object,
  changed: PropTypes.func
};

export default FilterItem;
